import { SVGProps } from 'react';

export const JCBIcon = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="76"
            height="45"
            viewBox="0 0 76 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M58.3219 31.5073C58.3219 34.9162 55.5461 37.6919 52.1373 37.6919H18.4873V13.197C18.4873 9.78821 21.2631 7.01245 24.6719 7.01245H58.3219V31.5073Z"
                fill="white"
            />
            <path
                d="M47.3652 25.2252H49.9219C49.9949 25.2252 50.1653 25.2008 50.2384 25.2008C50.7254 25.1034 51.1393 24.6652 51.1393 24.0564C51.1393 23.4721 50.7254 23.0338 50.2384 22.912C50.1653 22.8877 50.0193 22.8877 49.9219 22.8877H47.3652V25.2252Z"
                fill="url(#paint0_linear_1771_17906)"
            />
            <path
                d="M49.6297 9.08231C47.1948 9.08231 45.1982 11.0546 45.1982 13.5138V18.1157H51.4558C51.6019 18.1157 51.7723 18.1157 51.8941 18.1401C53.3063 18.2131 54.3533 18.9436 54.3533 20.2097C54.3533 21.208 53.6472 22.0602 52.3324 22.2306V22.2793C53.7689 22.3767 54.8646 23.1802 54.8646 24.422C54.8646 25.7612 53.6472 26.6378 52.0402 26.6378H45.1738V35.6468H51.675C54.1098 35.6468 56.1064 33.6746 56.1064 31.2153V9.08231H49.6297Z"
                fill="#11A704"
            />
            <path
                d="M50.8228 20.5017C50.8228 19.9173 50.4088 19.5278 49.9219 19.4547C49.8732 19.4547 49.7514 19.4304 49.6784 19.4304H47.3652V21.5731H49.6784C49.7514 21.5731 49.8975 21.5731 49.9219 21.5487C50.4088 21.4757 50.8228 21.0861 50.8228 20.5017Z"
                fill="url(#paint1_linear_1771_17906)"
            />
            <path
                d="M25.1345 9.08231C22.6997 9.08231 20.7031 11.0546 20.7031 13.5138V24.4464C21.9448 25.0551 23.2353 25.4447 24.5258 25.4447C26.0598 25.4447 26.8876 24.5194 26.8876 23.2533V18.0914H30.6861V23.2289C30.6861 25.2255 29.4443 26.8569 25.2319 26.8569C22.6753 26.8569 20.6787 26.2969 20.6787 26.2969V35.6225H27.1798C29.6147 35.6225 31.6113 33.6502 31.6113 31.191V9.08231H25.1345Z"
                fill="#0065C1"
            />
            <path
                d="M37.3817 9.08231C34.9468 9.08231 32.9502 11.0546 32.9502 13.5138V19.3088C34.0702 18.3592 36.0181 17.7505 39.1591 17.8966C40.8392 17.9696 42.641 18.4322 42.641 18.4322V20.3071C41.7401 19.8445 40.6688 19.4305 39.2809 19.3331C36.8947 19.1627 35.4581 20.3314 35.4581 22.3767C35.4581 24.4464 36.8947 25.6151 39.2809 25.4203C40.6688 25.3229 41.7401 24.8847 42.641 24.4464V26.3212C42.641 26.3212 40.8636 26.7839 39.1591 26.8569C36.0181 27.003 34.0702 26.3943 32.9502 25.4447V35.6712H39.4513C41.8862 35.6712 43.8828 33.6989 43.8828 31.2397V9.08231H37.3817Z"
                fill="#D30034"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1771_17906"
                    x1="45.1941"
                    y1="24.0593"
                    x2="56.1358"
                    y2="24.0593"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#007940" />
                    <stop offset="0.2285" stopColor="#00873F" />
                    <stop offset="0.7433" stopColor="#40A737" />
                    <stop offset="1" stopColor="#5CB531" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1771_17906"
                    x1="45.1939"
                    y1="20.4987"
                    x2="56.136"
                    y2="20.4987"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#007940" />
                    <stop offset="0.2285" stopColor="#00873F" />
                    <stop offset="0.7433" stopColor="#40A737" />
                    <stop offset="1" stopColor="#5CB531" />
                </linearGradient>
            </defs>
        </svg>
    );
};
